import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import sampleLogo from '../Assets/Images/HHG_Final_Logo_2.png';

const Header = () => {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const navLinks = [
    { to: '/', label: 'Home' },
    { to: '/Products', label: 'Products' },
    { to: '/about', label: 'About' },
    { to: '/Capabilities', label: 'Capabilities' },
    { to: '/ContactUs', label: 'Contact us' },
    { to: '/Career', label: 'Career' },
  ];

  // Update isMobile on window resize
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <header
      style={{
        backgroundColor: '#fff',
        position: 'sticky',
        top: 0,
        zIndex: 1000,
        padding: '10px 20px',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          maxWidth: '1300px',
          margin: '0 auto',
        }}
      >
        {/* Logo */}
        <a href="/">
          <img src={sampleLogo} alt="Logo" style={{ width: '120px', cursor: 'pointer' }} />
        </a>

        {/* Hamburger Icon for Mobile */}
        <div
          className="hamburger"
          onClick={() => setMenuOpen(!menuOpen)}
          style={{
            display: isMobile ? 'flex' : 'none',
            flexDirection: 'column',
            cursor: 'pointer',
          }}
        >
          <span style={{ height: '2px', width: '25px', background: '#000', margin: '4px 0' }} />
          <span style={{ height: '2px', width: '25px', background: '#000', margin: '4px 0' }} />
          <span style={{ height: '2px', width: '25px', background: '#000', margin: '4px 0' }} />
        </div>

        {/* Desktop Nav + Contact */}
        {!isMobile && (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <nav style={{ display: 'flex', marginRight: '30px', gap: '40px' }}>
              {navLinks.map((link, index) => (
                <a
                  key={index}
                  href={link.to}
                  style={{
                    color: location.pathname === link.to ? '#FFD700' : '#000',
                    fontWeight: '400',
                    fontFamily: 'Kanit, sans-serif',
                    fontSize: '18px',
                    textDecoration: 'none',
                    borderBottom: location.pathname === link.to ? '2px solid #FFD700' : 'none',
                    transition: 'color 0.3s ease',
                  }}
                  onMouseEnter={(e) => {
                    if (location.pathname !== link.to) e.target.style.color = '#FFD700';
                  }}
                  onMouseLeave={(e) => {
                    if (location.pathname !== link.to) e.target.style.color = '#000';
                  }}
                >
                  {link.label}
                </a>
              ))}
            </nav>

            {/* Contact Button */}
            <a
              href="tel:+919726055997"
              style={{
                backgroundColor: '#FFD700',
                color: '#000',
                padding: '10px 20px',
                fontWeight: '600',
                borderRadius: '28px',
                textDecoration: 'none',
                fontFamily: 'Kanit, sans-serif',
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#fff';
                e.target.style.border = '1px solid #000';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = '#FFD700';
                e.target.style.border = 'none';
              }}
            >
              <i className="fas fa-phone-alt" style={{ marginRight: '10px' }}></i>
              +91 97260 55997
            </a>
          </div>
        )}

        {/* Mobile Nav Links */}
        {isMobile && (
          <nav
            className={`nav-links ${menuOpen ? 'open' : ''}`}
            style={{
              display: menuOpen ? 'flex' : 'none',
              flexDirection: 'column',
              width: '100%',
              gap: '15px',
              marginTop: '15px',
            }}
          >
            {navLinks.map((link, index) => (
              <a
                key={index}
                href={link.to}
                style={{
                  color: location.pathname === link.to ? '#FFD700' : '#000',
                  fontWeight: '400',
                  fontFamily: 'Kanit, sans-serif',
                  fontSize: '18px',
                  textDecoration: 'none',
                  borderBottom: location.pathname === link.to ? '2px solid #FFD700' : 'none',
                  padding: '8px 0',
                }}
              >
                {link.label}
              </a>
            ))}

            <a
              href="tel:+919726055997"
              style={{
                backgroundColor: '#FFD700',
                color: '#000',
                padding: '10px 15px',
                fontWeight: '600',
                borderRadius: '28px',
                textDecoration: 'none',
                fontFamily: 'Kanit, sans-serif',
              }}
            >
              <i className="fas fa-phone-alt" style={{ marginRight: '10px' }}></i>
              +91 97260 55997
            </a>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
